import auth from "@/middleware/auth";

export default [
    {
        path: "propostasContencioso",
        name: "propostasContencioso",
        meta: { middleware: [auth] },
        component: () => import("./PropostasContencioso")
    }
];
